import React  from "react";  
window.addEventListener("scroll", () => {
  const number = document.getElementsByClassName('number');

  // console.log(number);
  let i;
  for(i=0; i<number.length;i++){
      const con_Position = number[i].getBoundingClientRect().top;
      const scr_position = window.innerHeight;
      if(con_Position < scr_position){
          const speed = 100000;
          for(let i= 0; i<number.length;i++){
              incNumber(number[i]);
          } 
          function incNumber(elem) {
              let text = +elem.innerText;
              const value = +elem.getAttribute("data-target");
              const inc = value / speed;
              if (text < value) {
                  elem.innerText = Math.ceil(inc + text);
                  setTimeout(() => {
                      incNumber(elem);
                  },1000);
              } else {
                  elem.innerText = Math.ceil(value);
              }
          }
      }
  }
})
const About = () => {

  return (
    <section className="about p-top p-btm" id="about">
      <div className="container">
        <div className="flex spce-btwn align-center">
          <div className="left">
            <img
              src="./Assets/img/about.png"
              alt="about"
              className="img-fluid"
            />
            <div className="experence flex spce-btwn align-cntr">
              <div className="left container">
              <div className="num">
                     <span><span className="number" data-target="20">0</span> +</span>
                  </div>
                <p>Years Of Experience</p>
              </div>
              <div className="right d-none">
                <img
                  src="./Assets/img/banner1.jpg"
                  alt="experience"
                  className="img-fluid"
                />
              </div>
            </div>
          </div>
          <div className="right">
            <span className="title">Our Company</span>
            <h2>We Vow For Your Success</h2>
            <p>
              Techsaga Corporation is incorporated on the foundation of a
              multidisciplinary team inherited with a proven track record and
              eminent talent. In the herd of our fellow strategists, designers,
              and innovators, we are accountable for the client's delight and
              exceeded expectations.
            </p>
            <p>
              Techsaga was once a project of inventive minds who realized the
              potency of IT applications in the score of IT field way ahead in
              the year 2012. We aspire to make the customers in the last row
              contented and satisfied by our righteous approach of attainment.
            </p>

            <a href="/" className="glbl-btn" id="glbl-btn">
              Read More
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};
export default About;
